import Toggle_module_default from "./Toggle.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Control } from "@radix-ui/react-form";
//#region src/components/Form/Controls/Toggle/Toggle.tsx
/**
* A toggle component.
*/
var ToggleInput = forwardRef(function Toggle({ className, ...props }, ref) {
	return /* @__PURE__ */ jsxs("div", {
		className: classNames(Toggle_module_default.container, className),
		children: [/* @__PURE__ */ jsx("input", {
			role: "switch",
			ref,
			className: Toggle_module_default.input,
			...props,
			type: "checkbox"
		}), /* @__PURE__ */ jsx("div", { className: Toggle_module_default.ui })]
	});
});
/**
* A styled checkbox input wrapped in a `Control` component, for use in Radix forms.
*/
var ToggleControl = forwardRef(function ToggleControl(props, ref) {
	return /* @__PURE__ */ jsx(Control, {
		asChild: true,
		children: /* @__PURE__ */ jsx(ToggleInput, {
			ref,
			...props
		})
	});
});
//#endregion
export { ToggleControl, ToggleInput };

//# sourceMappingURL=Toggle.js.map